<template>
    <div class="bo-cell-per-total">
        <vue-numeric
            v-if="editable"
            :minus="meta.sign"
            :precision="meta.decimal"
            :field="id"
            :min="0"
            :max="amount[meta.denominator]"
            v-model="amount[meta.numerator]"
            @input="changedValue($event)"
        ></vue-numeric>
        <span class="amount" v-else>{{ amount[meta.numerator] }}</span
        ><span v-if="!meta.hideDenominator" class="input-group-text"
            >/
            {{ amount[meta.denominator] }}
        </span>
    </div>
</template>

<script>
import Vue from "vue";
import VueNumeric from "vue-numeric";
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);

export default {
    props: {
        meta: {
            type: Object,
            default: () => ({}),
        },
        editable: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: "",
        },
        value: {
            type: Object,
            default: () => ({}),
        },
        eager: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        VueNumeric,
    },

    data() {
        return {
            amount: Vue.util.extend({}, this.value),
        };
    },

    watch: {
        value: {
            handler(n, o) {
                this.amount = Vue.util.extend({}, n);
            },
            deep: true,
        },
    },

    methods: {
        changedValue(value) {
            if (this.eager || this.value[this.meta.numerator] !== value) {
                this.$emit("change", this.amount);
            }
        },
    },
};
</script>